// Mirrors the `friendlyLabel` values declared on each orchestrator tool in
// backend-nest/src/chat/tools/*.tool.ts. The backend only persists
// {id, name, input, error, durationMs} per tool call (see
// ConversationService.getMessages flatten), not the label itself, so the
// frontend keeps its own copy to render human-readable tool activity.
// Unknown tool names fall back to a humanized version of the snake_case name
// so a new backend tool never renders as a blank label.
const TOOL_FRIENDLY_LABELS: Record<string, string> = {
  web_search: 'Searching the web',
  enrich_profile: 'Queuing profile enrichment',
  create_lead: 'Creating a new lead',
  create_leads_from_research: 'Creating leads from research results',
  add_note: 'Adding a note to a lead',
  assign_lead: 'Assigning lead to a team member',
  update_lead_fields: 'Updating lead details',
  add_tags: 'Adding tags to a lead',
  move_lead_stage: 'Moving lead to a new stage',
  search_leads: 'Searching your leads',
  get_lead_details: 'Looking up lead details',
  search_research_companies: 'Checking cached company research',
  invoke_prospect_search: 'Starting deep research across LinkedIn, web and Instagram',
  send_whatsapp_message: 'Sending a WhatsApp message',
  echo: 'Echoing input',
};

export function getToolFriendlyLabel(toolName: string): string {
  return TOOL_FRIENDLY_LABELS[toolName] ?? humanizeToolName(toolName);
}

function humanizeToolName(toolName: string): string {
  if (!toolName) return 'Running a tool';
  return toolName
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
